import { useState, useRef } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";

import { postMethod } from "../api/HTTPServices";
import { ErrorData } from "../helpers/helper";
import imageCompression from "browser-image-compression";

export const useCompressedImageUpload = (
  AudienceID,
  handleClose,
  roomToken,
  successFullUploadCallBack
) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg, image/png",
    multiple: false,
    maxSize: 10400000,
  }); // max file size: 10 MB
  const [source] = useState(axios.CancelToken.source());
  const [description, setDescription] = useState("");
  const [success, setSuccess] = useState([]);
  const [failed, setFailed] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [currentUploadFile, setCurrentUploadFile] = useState("");
  const [process, setProcess] = useState(0);
  const descriptionInputRef = useRef(null);

  const upload = () => {
    console.log("this is data")
    setUploading(true);
    acceptedFiles.forEach((file, index) => {
      if (success.indexOf(file.name) !== -1) {
        return;
      }

      var imageFile = file;
      // console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
      // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

      var options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        fileType: "image/png",
      };
      imageCompression(imageFile, options)
        .then(function (compressedFile) {
          // console.log(
          //   "compressedFile instanceof Blob",
          //   compressedFile instanceof Blob
          // ); // true
          // console.log(
          //   `compressedFile size ${compressedFile.size / 1024 / 1024} MB`
          // ); // smaller than maxSizeMB
          // console.log("compressedFile", compressedFile);
          // console.log("file", file);

          var fileFromBlob = new File([compressedFile], compressedFile.name, {
            type: "image/png",
            lastModified: Date.now(),
          });

          setCurrentUploadFile(compressedFile.name);
          var data = new FormData();
          data.append("message", description);
          data.append("audience", AudienceID);
          data.append("type", "jpg");
          data.append("file", fileFromBlob);
          data.append("room_token", roomToken);
         

          const RequestService = postMethod(
            "chat",
            data,
            "true",
            "post",
            "false",
            "",
            false,
            (ProgressEvent) => {
              setProcess((ProgressEvent.loaded / ProgressEvent.total) * 100);
            },
            () => {
              setFailed([...failed, file.name]);
              setUploading(false);
              console.log("er")
              ErrorData("اپلود فایل با خطا مواجه شد. لطفا دوباره تلاش کنید.");
            },
            source.token
          );
          RequestService.then(function (response) {
            if (response) {
              
              setSuccess([...success, file.name]);
              successFullUploadCallBack(response);
            
            }else{
              
            }
          });
        })
        .catch(function (error) {
          console.log("ammir",error.message);
        });
    });
  };

  const close = () => {
    source.cancel("upload operation canceled by user");
    handleClose();
  };

  return {
    getRootProps,
    getInputProps,
    setDescription,
    setCurrentUploadFile,
    upload,
    close,
    description,
    uploading,
    currentUploadFile,
    process,
    acceptedFiles,
    success,
    failed,
    descriptionInputRef,
  };
};
